export enum LoginConstants {
	ACCESS_TOKEN = 'accessToken',
	REFRESH_TOKEN = 'refreshToken',
	REFRESHING_TOKEN = 'refreshingToken',
	UNLOADING_PAGE = 'unloading',
	EXPIRE_TIME = 'expireTime',
	INVALID_CLIENT = 'invalid_client',
	INVALID_GRANT = 'invalid_grant',
	INVALID_TOKEN = 'invalid_token',
}
